import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Thermometer, Activity, Brain } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-20 bg-[#F0EBE5]" data-id="element-129">
      <div className="max-w-4xl mx-auto px-4" data-id="element-130">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} data-id="element-131">
          <div className="text-center mb-16" data-id="element-132">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#2C2C2C]" data-id="element-133">
              The Moment You Dread
            </h2>
            <p className="text-lg text-[#4A4A4A] max-w-2xl mx-auto" data-id="element-134">
              You wake up and instantly know: <em data-id="element-135">it's happening again.</em>
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-136">
            <motion.div variants={itemVariants} className="bg-[#FAF8F5] p-8 rounded-xl border border-[#E5E0D8]" data-id="element-137">
              <div className="flex items-start mb-4" data-id="element-138">
                <Activity className="w-6 h-6 text-[#FC8EAC] mr-3 mt-1" data-id="element-139" />
                <div data-id="element-140">
                  <h3 className="text-xl font-bold mb-2" data-id="element-141">The Body Alarm</h3>
                  <p className="text-[#4A4A4A]" data-id="element-142">
                    Maybe you're hot. Or sweaty. Or cold right after. Maybe your
                    heart isn't racing… but your brain is.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-[#FAF8F5] p-8 rounded-xl border border-[#E5E0D8]" data-id="element-143">
              <div className="flex items-start mb-4" data-id="element-144">
                <Brain className="w-6 h-6 text-[#FC8EAC] mr-3 mt-1" data-id="element-145" />
                <div data-id="element-146">
                  <h3 className="text-xl font-bold mb-2" data-id="element-147">The Mind Spiral</h3>
                  <p className="text-[#4A4A4A]" data-id="element-148">
                    <em data-id="element-149">"I have to be functional tomorrow."</em>
                    <br data-id="element-150" />
                    <em data-id="element-151">"Why am I awake?"</em>
                    <br data-id="element-152" />
                    <em data-id="element-153">"What if I can't get back to sleep?"</em>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          <motion.div variants={itemVariants} className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border-l-4 border-[#FC8EAC]" data-id="element-154">
            <h3 className="text-2xl font-bold mb-4 font-serif" data-id="element-155">
              Here's the truth nobody makes obvious
            </h3>
            <p className="text-lg text-[#4A4A4A] mb-6" data-id="element-156">
              Menopause sleep problems often aren't solved by "one more calming
              trick." Because when you wake at 3am, your brain is usually doing
              something logical: it's trying to explain an{' '}
              <strong data-id="element-157">activated body</strong>.
            </p>
            <p className="text-lg font-semibold text-[#2C2C2C]" data-id="element-158">
              So you can't start with mindset. You have to start with the alarm.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}